import { useTranslate } from '@tolgee/react';
import { ActionEnum, SubjectEnum } from 'abi-genome-common-types';

import { useAbility } from '~/contexts';

import { Icon } from '../../Icon';

export function TeamAndRoles({
  teamName,
}: {
  teamName: string;
}) {
  const { t } = useTranslate();
  const abilities = useAbility()
  const isApprover = abilities.can(ActionEnum.Approve, SubjectEnum.Ticket) && abilities.can(ActionEnum.Reject, SubjectEnum.Ticket);
  return (
    <div className="bg-[#F5F6F7] w-full p-4 mt-4 rounded-lg mt-4 mb-2">
      <div>
        {teamName && (
          <>
            <div className="flex items-center gap-3 mb-3">
              <Icon isCustom size={16} icon="users" />
              <span className="text-[#191F2E] font-[700]">
                {t('common.current_team')}
              </span>
            </div>
            <div className="text-gray-600 mb-4">
              <span className="text-sm">{teamName}</span>
            </div>
          </>
        )}
        <div
          className={`flex items-center gap-3 mb-3 ${teamName ? 'mt-4' : ''}`}
        >
          <Icon isCustom size={16} icon="user" />
          <span className="text-[#191F2E] font-[700]">
            {t('common.current_roles')}
          </span>
        </div>
        <div className="text-gray-600 mb-4 flex flex-col gap-1">
          {isApprover && (
            <span className="text-sm text-[#3F465A]">
              {t('common.roles.approver')}
            </span>
          )}
          <span className="text-sm text-[#3F465A]">
            {' '}
            {t('common.roles.requestor')}
          </span>
        </div>
      </div>
    </div>
  );
}
